module.exports = __webpack_public_path__ + "static/home-poster-sm-aa5ae0a1867a3f2047046fd1423748fb.jpg";